const STATUS = {
  pending: 'Direview',
  approved: 'Disetujui',
  rejected: 'Ditolak',
};

export default STATUS;
